
const CATEGORY_HOME = 0;
const CATEGORY_SHOP = 1;

const list = {
	[CATEGORY_HOME]: {
		id: CATEGORY_HOME,
		title: 'Мои книги',
		routerName: 'shelves-my'
	},

	[CATEGORY_SHOP]: {
		id: CATEGORY_SHOP,
		title: 'Планирую купить',
		routerName: 'shelves-shop',
	}
};

class Category {

	static get TYPE_HOME() {
		return CATEGORY_HOME;
	}

	static get TYPE_SHOP() {
		return CATEGORY_SHOP;
	}

	static find(id) {
		return list[id] || null;
	}

}

export default Category;